const amt_admin = require('amt_admin').default;
const app = require('angular').module('ww2_analytics.game_events', [amt_admin]);
const features = [
  'summon_event',
  'champions_tournaments',
  'beginner_tournaments',
  'activity_event',
  'visits',
  'oil_battle_pass',
  'vip_battle_pass',
  'gold_battle_pass',
  'dogs_tags_battle_pass',
  'activity_event_summon',
  'arena_event',
];
const templates = Object.fromEntries(
  features.map(f => [f, require(`./${f}/view.html`)])
);

function build_state(key, title) {
  return {
    url: '/' + key,
    template: templates[key],
    reloadOnSearch: false,
    data: {
      priority: 903,
      title: title,
      role: 'game_events',
    },
  };
}

app.config(['$stateProvider', function ($stateProvider) {
  $stateProvider
    .state('amt.ww2.game_events', {
      url: '/game_events',
      abstract: true,
      template: '<div class="row" ui-view></div>',
      data: {
        priority: 902,
        title: 'Game Events',
        role: 'game_events',
      },
      menu: {
        glyphicon: 'time',
        childs: [
          { state: 'amt.ww2.game_events.champions_tournaments', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.beginner_tournaments', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.summon_event', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.activity_event', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.visits', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.oil_battle_pass', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.vip_battle_pass', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.gold_battle_pass', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.dogs_tags_battle_pass', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.activity_event_summon', glyphicon: 'time' },
          { state: 'amt.ww2.game_events.arena_event', glyphicon: 'time' },
        ],
      },
    })
    .state('amt.ww2.game_events.summon_event', build_state('summon_event', 'Summon Event'))
    .state('amt.ww2.game_events.champions_tournaments', build_state('champions_tournaments', 'Champions Tournaments'))
    .state('amt.ww2.game_events.beginner_tournaments', build_state('beginner_tournaments', 'Beginner Tournaments'))
    .state('amt.ww2.game_events.activity_event', build_state('activity_event', 'Activity Event'))
    .state('amt.ww2.game_events.visits', build_state('visits', 'Visits'))
    .state('amt.ww2.game_events.oil_battle_pass', build_state('oil_battle_pass', 'Oil Battle Pass'))
    .state('amt.ww2.game_events.vip_battle_pass', build_state('vip_battle_pass', 'Vip Battle Pass'))
    .state('amt.ww2.game_events.gold_battle_pass', build_state('gold_battle_pass', 'Gold Battle Pass'))
    .state('amt.ww2.game_events.dogs_tags_battle_pass', build_state('dogs_tags_battle_pass', 'Dogs Tags Battle Pass'))
    .state('amt.ww2.game_events.activity_event_summon', build_state('activity_event_summon', 'Activity Event Summon'))
    .state('amt.ww2.game_events.arena_event', build_state('arena_event', 'Arena Event'))
  },
]);

export default app.name;
